module.exports = __webpack_public_path__ + "static/media/engine.e089841c.jpg";